import React from 'react';
import { Element } from 'react-scroll';
import About from './About';
import Contact from './Contact';
import { FAQs } from './FAQs';
import Features from './Features';
import Hero from './Hero';
import { Pricing } from './Pricing';

const Home = () => {
  return (
    <div>
      <Element name='hero'>
        <Hero />
      </Element>
      <Element name='about'>
        <About />
      </Element>
      <Element name='features'>
        <Features />
      </Element>
      <Element name='faqs'>
        <FAQs />
      </Element>
      <Element name='pricing'>
        <Pricing />
      </Element>
    </div>
  );
};

export default Home;
